<template>
  <div id="user">
    <el-container class="container common">
      <el-aside class="aside" width="200px" >
        <div
          style="padding: 24px 0 24px 24px;border-top: 1px solid #EAEAE0;border-bottom: 1px solid #EAEAE0;">
          <p style="margin-bottom: 4px;">欢迎您：</p>
          <p>sw122852567</p>
        </div>
        <el-menu router :default-active="$route.path" class="el-menu-vertical-demo"
          background-color="#fff" text-color="#333333" active-text-color="#77BA00">
          <el-menu-item style="margin-top:23px" class="el-menu-item " index="/user/service"
            :class="{on:$route.path.includes('/singleService')}">
            <i class="el-icon-s-operation"></i>
            <span slot="title">我的服务</span>
          </el-menu-item>
          <el-menu-item index="/user/record" :class="{on:$route.path.includes('/singleRecord')}">
            <i class="el-icon-tickets"></i>
            <span slot="title">服务记录</span>
          </el-menu-item>
          <el-menu-item index="/user">
            <i class="el-icon-user"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
          <el-menu-item index="/user/change">
            <i class="el-icon-setting"></i>
            <span slot="title">修改密码</span>
          </el-menu-item>
<!--          <el-submenu class="el-submenu" index="/user">-->
<!--            <template slot="title">-->
<!--              <i class="el-icon-setting"></i>-->
<!--              <span>账号安全</span>-->
<!--            </template>-->
<!--            <el-menu-item-group>-->
<!--              <el-menu-item index="/user/forget">密码找回</el-menu-item>-->
<!--              <el-menu-item index="/user/change">修改密码</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--          </el-submenu>-->
        </el-menu>
      </el-aside>
      <el-main class="main ">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    return {
    }
  },
}
</script>

<style scoped>
.common{
  min-width: 1180px;
}
.container {
  background-color: #f5f5f5;
}
.aside {
  background-color: #fff;
}
.el-menu-item {
  height: 40px;
  line-height: 40px;
}
::v-deep .el-menu-item-group__title {
  padding: 0;
}
::v-deep .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}
::v-deep .el-submenu__title:hover {
  background-color: #77ba00 !important;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
}
.el-menu-item:hover {
  background-color: #77ba00 !important;
}
.el-menu-item.is-active {
  background-color: #f1f8e5 !important;
  border-right: 4px solid #77ba00;
}
.on {
  background-color: #f1f8e5 !important;
  border-right: 4px solid #77ba00;
  color: #77ba00 !important;
}
.on:hover {
  background-color: #f1f8e5 !important;
  border-right: 4px solid #77ba00;
  color: #77ba00 !important;
}
.on i {
  color: #77ba00 !important;
}
.main{
  /*height: 100%;*/
  /*min-width:1580px;*/
}
</style>